<template>
  <div>
    <div v-show="warningVisible" :style="{position: 'absolute',top: 0,left: 0,width: '100vw',height: '2vh',backgroundImage: linecolor[0],zIndex: 999}">
    </div>
    <div v-show="warningVisible" :style="{position: 'absolute',top: 0,left: 0,width: '1vw',height: '100vh',backgroundImage: linecolor[1],zIndex: 999}">
    </div>
    <div v-show="warningVisible" :style="{position: 'absolute',right: 0,bottom: 0,width: '100vw',height: '2vh',backgroundImage: linecolor[2],zIndex: 999}">
    </div>
    <div v-show="warningVisible" :style="{position: 'absolute',right: 0,bottom: 0,width: '1vw',height: '100vh',backgroundImage: linecolor[3],zIndex: 999}">
    </div>
<!--    <div v-show="warningVisible" style="position: absolute;right: 0;bottom: 0;width: 1vw;height: 100vh;background-image: linear-gradient(to left, red, transparent);z-index: 999">-->
<!--    </div>-->
    <div id="components-layout-demo-basic">
      <a-layout>
        <a-layout-sider width="18%" style="border-right: 10px solid #eeeeee;">
          <div style="height: 13%">
            <img style="width: 100%;padding: 20px" :src="logo">
          </div>
          <div style="height: 35%;background-color: #fff">
            <a-divider class="divider">员工信息</a-divider>
            <a-row type="flex">
              <a-col :span="12" style="text-align: left;font-size: 25px">
                <img style="width: 100%;height: 100%" src="http://61.164.90.254:9004/111.jpg">
              </a-col>
            </a-row>
            <a-row type="flex" class="row">
              <a-col :span="9">
                员工编号：
              </a-col>
              <a-col :span="10">
                {{userCode}}
              </a-col>
            </a-row>
            <a-row type="flex" class="row">
              <a-col :span="9">
                员工姓名：
              </a-col>
              <a-col :span="10">
                {{userName}}
              </a-col>
            </a-row>
            <a-row type="flex" class="row">
              <a-col :span="9">
                所属部门：
              </a-col>
              <a-col :span="10">
                {{userDepartment}}
              </a-col>
            </a-row>
          </div>
          <div style="height: 55%;background-color: #fff">
            <a-divider class="divider">产品信息</a-divider>
            <a-row type="flex" class="row">
              <a-col :span="9">
                流转卡号：
              </a-col>
              <a-col :span="15">
                {{cardCode}}
              </a-col>
            </a-row>
            <a-row type="flex" class="row">
              <a-col :span="9">
                物料名称：
              </a-col>
              <a-col :span="15">
                {{cardprName}}
              </a-col>
            </a-row>
            <a-row type="flex" class="row">
              <a-col :span="9">
                规格型号：
              </a-col>
              <a-col :span="15">
                {{cardModel}}
              </a-col>
            </a-row>
            <a-row type="flex" class="row">
              <a-col :span="9">
                整机编号：
              </a-col>
              <a-col :span="15">
                {{cardBatch}}
              </a-col>
            </a-row>
            <a-input id="focus" v-model="focusData" style="width: 30px" @keyup.enter="getfocus"></a-input>
          </div>
        </a-layout-sider>
        <a-layout>
          <a-layout-header style="display: flex;align-items: center;justify-content: space-around;flex-direction: row">
            <div style="font-size: 70px;font-family:b">德曼精益生产系统</div>
          </a-layout-header>
          <a-layout-content>
            <a-divider class="divider">工序进度</a-divider>
            <div style="width: 100%">
              <a-steps :current=current style="width: 100%;padding: 30px;">
                <a-step v-for="step in steps" :key="step.name" :title="step.status" :description="step.name">
                </a-step>
              </a-steps>
            </div>
            <a-divider class="divider">工序计时</a-divider>
            <div style="font-size: 80px;color: #319ff3;">
              <a-row type="flex">
                <a-col :span="9" style="text-align: right">
                  <span>{{countdown}}</span>
                </a-col>
                <a-col :span="12">
                  <span>{{processesTime}}</span>
                </a-col>
<!--                <a-col :span="6"  style="text-align: right">-->
<!--                  <span>已用时间:</span>-->
<!--                </a-col>-->
<!--                <a-col :span="6">-->
<!--                  <span>{{userTime}}</span>-->
<!--                </a-col>-->
              </a-row>
              <div>
                <a-row type="flex">
                  <a-col :span="22" offset="1">
                    <a-progress :strokeWidth="60" :strokeColor="{'0%': '#87d068','100%': '#87d068',}" :percent="percent" status="active" />
                  </a-col>
                </a-row>
              </div>
            </div>
          </a-layout-content>
          <a-layout-footer>
            <a-divider class="divider">工序汇报</a-divider>
            <a-row type="flex" class="footrow">
              <a-col :span="1">
                <a-button style="font-size: 20px;height: 150px;width: 50px;margin-top: 13px;white-space: normal" @click="click('工序汇报')" >工序汇报</a-button>
              </a-col>
              <a-col :span="4">
                <img style="width: 70%;height: 100%" src="http://61.164.90.254:9004/shengchan/工序汇报.png">
              </a-col>
              <a-col :span="1" offset="4">
                <a-button style="font-size: 20px;height: 150px;width: 50px;margin-top: 13px;white-space: normal" @click="click('异常安灯')">异常安灯</a-button>
              </a-col>
              <a-col :span="4">
                <img style="width: 70%;height: 100%" src="http://61.164.90.254:9004/shengchan/异常安灯.png">
              </a-col>
              <a-col :span="1" offset="4">
                <a-button style="font-size: 20px;height: 150px;width: 50px;margin-top: 13px;white-space: normal" @click="click('完工退出')">完工退出</a-button>
              </a-col>
              <a-col :span="4">
                <img style="width: 70%;height: 100%" src="http://61.164.90.254:9004/shengchan/完工退出.png">
              </a-col>
            </a-row>
          </a-layout-footer>
        </a-layout>
      </a-layout>
    </div>
    <a-modal style="background-color: #319ff3" :width="700" :visible="cardVisible" :closable="false" title="请输入流转卡" :footer="null" centered @cancel="cancel" >
      <a-input id="cardId" v-model="cardId" @keyup.enter="getCard">
        <a-icon slot="prefix" type="reconciliation" />
      </a-input>
    </a-modal>
    <a-modal style="background-color: #319ff3"  :width="700" :visible="userVisible" :closable="false" title="请输入员工编号" :footer="null" centered @cancel="cancel" >
      <a-input id="userId" v-model="userId" @keyup.enter="getUser">
        <a-icon slot="prefix" type="user" />
      </a-input>
    </a-modal>
    <a-modal style="background-color: #319ff3" :width="500" :visible="callVisible" title="异常处理中" :closable="false" :footer="null" centered   @cancel="cancel" >
      <a-row type="flex" style="font-size: 30px;color: #319ff3">
        <a-col :span="6">
          <span>呼叫人:</span>
        </a-col>
        <a-col :span="6">
          <span>{{userName}}</span>
        </a-col>
        <a-col :span="6">
          <span>处理人:</span>
        </a-col>
        <a-col :span="6">
          <span>{{callName}}</span>
        </a-col>
      </a-row>
      <a-row type="flex" justify="center">
      </a-row>
      <a-row type="flex" justify="center" style="margin-top: 20px">
        <a-col :span="6">
          <a-button @click="callClick" >处理完成</a-button>
        </a-col>
      </a-row>
    </a-modal>
    <a-drawer
      title="语音呼叫"
      placement="bottom"
      :closable="false"
      :visible="drawerVisible"
      :height="350"
      :after-visible-change="afterVisibleChange"
      @close="onClose"
    >
      <a-row type="flex" class="footrow">
        <a-col :span="1">
          <a-button style="font-size: 20px;height: 150px;width: 50px;margin-top: 13px;white-space: normal" @click="drawerClick('技术')" >呼叫技术</a-button>
        </a-col>
        <a-col :span="4">
          <img style="width: 70%;height: 100%" src="http://61.164.90.254:9004/shengchan/技术.png">
        </a-col>
        <a-col :span="1" offset="1">
          <a-button style="font-size: 20px;height: 150px;width: 50px;margin-top: 13px;white-space: normal" @click="drawerClick('仓库')">呼叫仓库</a-button>
        </a-col>
        <a-col :span="4">
          <img style="width: 70%;height: 100%" src="http://61.164.90.254:9004/shengchan/仓库.png">
        </a-col>
        <a-col :span="1" offset="1">
          <a-button style="font-size: 20px;height: 150px;width: 50px;margin-top: 13px;white-space: normal" @click="drawerClick('品质')">呼叫品质</a-button>
        </a-col>
        <a-col :span="4">
          <img style="width: 70%;height: 100%" src="http://61.164.90.254:9004/shengchan/品质.png">
        </a-col>
        <a-col :span="1" offset="1">
          <a-button style="font-size: 20px;height: 150px;width: 50px;margin-top: 13px;white-space: normal" @click="drawerClick('主管')">呼叫主管</a-button>
        </a-col>
        <a-col :span="4">
          <img style="width: 70%;height: 100%" src="http://61.164.90.254:9004/shengchan/主管.png">
        </a-col>
      </a-row>
    </a-drawer>
  </div>
</template>

<script>

import url from '@/assets/logo.png'
import mesApi from '../../../api/mes'
import moment from 'moment'

export default {
  name: 'index',
  created () {
    setInterval(() => {
      // this.warningVisible = !this.warningVisible
      this.focusData = ''
      if (this.cardCode !== '' && !this.callVisible) {
        this.timeSecond++
        this.percent = Math.ceil(this.timeSecond / this.steps[this.current].time * 100)
        if (this.percent > 100) {
          this.linecolor[0] = 'linear-gradient(to bottom, red, transparent)'
          this.linecolor[1] = 'linear-gradient(to right, red, transparent)'
          this.linecolor[2] = 'linear-gradient(to top, red, transparent)'
          this.linecolor[3] = 'linear-gradient(to left, red, transparent)'
          this.warningVisible = !this.warningVisible
        } else if (this.percent > 90) {
          this.linecolor[0] = 'linear-gradient(to bottom, orange, transparent)'
          this.linecolor[1] = 'linear-gradient(to right, orange, transparent)'
          this.linecolor[2] = 'linear-gradient(to top, orange, transparent)'
          this.linecolor[3] = 'linear-gradient(to left, orange, transparent)'
          this.timeOutColor = '#ff0000'
          this.warningVisible = !this.warningVisible
        }
        this.userTime = this.timeFormat(this.timeSecond)
        if (this.steps[this.current].time - this.timeSecond >= 0) {
          this.countdown = '倒计时:'
          this.processesTime = this.timeFormat(this.steps[this.current].time - this.timeSecond)
        } else {
          this.countdown = '已超时:'
          this.processesTime = this.timeFormat(this.timeSecond - this.steps[this.current].time)
        }
      }
    }, 1000)
  },
  mounted () {
    setTimeout(() => {
      document.getElementById('userId').focus()
    }, 0)
  },
  data () {
    return {
      logo: url,
      processesTime: '',
      userTime: '',
      timeSecond: 0,
      warningVisible: false,
      userVisible: true,
      cardVisible: true,
      drawerVisible: false,
      callVisible: false,
      percent: 0,
      userId: '',
      userCode: '',
      userName: '',
      userDepartment: '',
      cardId: '',
      cardModel: '',
      cardCode: '',
      cardprName: '',
      cardprCode: '',
      cardBatch: '',
      focus: '',
      steps: [],
      current: 0,
      countdown: '',
      linecolor: [],
      timeOutColor: '#319ff3',
      callName: '',
      focusData: ''
    }
  },
  methods: {
    timeFormat (second) {
      let hour = 0
      let minute = 0
      let second1 = 0
      hour = Math.floor(second / 3600)
      minute = Math.floor(second % 3600 / 60)
      second1 = Math.floor(second % 3600 % 60)
      if (hour < 10) {
        hour = `0${hour}`
      }
      if (minute < 10) {
        minute = `0${minute}`
      }
      if (second1 < 10) {
        second1 = `0${second1}`
      }
      return `${hour}时${minute}分${second1}秒`
    },
    cancel (e) {
      if (this.userVisible) {
        document.getElementById('userId').focus()
      } else if (this.cardVisible) {
        document.getElementById('cardId').focus()
      } else {
        document.getElementById('focus').focus()
      }
    },
    setCurrent (current) {
      this.timeSecond = 0
      this.steps.forEach((step, index) => {
        if (current > index) {
          step.status = '已完成'
        } else if (current === index) {
          step.status = '进行中'
        } else {
          step.status = '未完成'
        }
      })
      if (current === this.steps.length) {
        setTimeout(() => {
          location.reload()
        }, 0)
      }
    },
    getProcesses () {
      if (this.cardprCode.length < 5) {
        this.$message.error('流转卡号错误！', 1)
        return
      }
      mesApi.getProcesses(this.cardprCode).then(({ data, code }) => {
        if (code === 0) {
          this.steps = data
          this.current = 0
          this.setCurrent(this.current)
        } else {
          this.$message.error('流转卡号错误！', 1)
        }
        this.loading = false
      }).then(() => {
        mesApi.getHistoryProcesses(this.cardId).then(({ data }) => {
          if (data !== null) {
            if (data === this.steps.length) {
              setTimeout(() => {
                location.reload()
              }, 0)
            }
            this.current = data
            this.setCurrent(this.current)
          }
        }).catch(({ message }) => {
          this.$message.error(message)
        }).finally(() => {
          this.loading = false
        })
      }).catch(({ message }) => {
        this.$message.error(message)
      })
    },
    getUser (e) {
      if (this.userId.length < 5) {
        this.$message.error('员工编号不存在！', 1)
        return
      }
      mesApi.getUser(this.userId).then((data) => {
        if (data.code === 0) {
          this.userCode = data.data.code
          this.userName = data.data.name
          this.userDepartment = data.data.department
          this.userVisible = false
          if (this.cardVisible) {
            setTimeout(() => {
              if (!this.userVisible) {
                document.getElementById('cardId').focus()
              } else {
                document.getElementById('focus').focus()
              }
            }, 0)
          } else {
            document.getElementById('focus').focus()
          }
        } else {
          this.$message.error('员工编号不存在，登入失败！', 1)
        }
        this.loading = false
      }).catch(({ message }) => {
        this.$message.error(message)
      })
    },
    getCard (e) {
      mesApi.getCard(this.cardId).then((data) => {

        if (data.code === 0) {
          this.cardCode = data.data.code
          this.cardBatch = data.data.batch
          this.cardprName = data.data.prName
          this.cardprCode = data.data.prCode
          this.cardModel = data.data.model
          this.cardVisible = false
          setTimeout(() => {
            if (!this.cardVisible) {
              document.getElementById('focus').focus()
            }
          }, 0)
        } else {
          this.$message.error('员工编号不存在，登入失败！', 1)
        }
        this.getProcesses(this.cardprCode)
      }).catch(({ message }) => {
        this.$message.error(message)
      })
    },
    getfocus (event) {
      if (this.focusData === 'gongxuhuibao') {
        this.focusData = ''
        if (this.timeSecond < 60) {
          this.$message.error('请在1分钟后再进行工序汇报', 1)
          return
        }
        mesApi.insertProcesses(this.timeSecond, this.userCode, this.userName, this.userDepartment, this.cardCode, this.cardBatch,
          this.cardModel, this.cardprName, this.cardprCode, this.steps[this.current].name, this.steps[this.current].id, moment().format('YYYY-MM-DD HH:mm:ss')).then((data) => {

          if (data.code === 0) {
          } else {
            this.$message.error('员工编号不存在，登入失败！', 1)
          }
          this.loading = false
        }).catch(({ message }) => {
          this.$message.error(message)
        })
        this.warningVisible = false
        this.current++
        this.setCurrent(this.current)
      }
      if (this.focusData === 'yichangandeng') {
        this.focusData = ''
        this.drawerVisible = true
      }
      if (this.focusData === 'wangongtuichu') {
        this.focusData = ''
        setTimeout(() => {
          location.reload()
        }, 0)
      }
    },
    callClick () {
      this.callVisible = false
    },
    drawerClick (event) {
      mesApi.call(this.userName, event).then(({ data }) => {

        if (data === 'OK') {
          this.$message.info('呼叫成功！', 3)
          this.callName = event
          this.drawerVisible = false
          this.callVisible = true
        } else {
          this.drawerVisible = false
          this.$message.error(data, 3)
        }
        this.loading = false
      }).catch(({ message }) => {
        this.$message.error(message)
      })
    },
    click (event) {
      document.getElementById('focus').focus()
      if (event === '工序汇报') {
        if (this.timeSecond < 60) {
          this.$message.error('请在1分钟后再进行工序汇报', 1)
          return
        }
        mesApi.insertProcesses(this.timeSecond, this.userCode, this.userName, this.userDepartment, this.cardCode, this.cardBatch,
          this.cardModel, this.cardprName, this.cardprCode, this.steps[this.current].name, this.steps[this.current].id, moment().format('YYYY-MM-DD HH:mm:ss')).then((data) => {

          if (data.code === 0) {
          } else {
            this.$message.error('员工编号不存在，登入失败！', 1)
          }
          this.loading = false
        }).catch(({ message }) => {
          this.$message.error(message)
        })
        this.warningVisible = false
        this.current++
        this.setCurrent(this.current)
      }
      if (event === '异常安灯') {
        this.drawerVisible = true
      }
      if (event === '完工退出') {
        setTimeout(() => {
          location.reload()
        }, 0)
      }
    },
    afterVisibleChange (val) {
      console.log('visible',val)
    },
    showDrawer () {
      this.drawerVisible = true
    },
    onClose () {
      setTimeout(() => {
        document.getElementById('focus').focus()
      }, 0)
      this.drawerVisible = false
    }
  }
}
</script>

<style scoped>
#components-layout-demo-basic {
  width: 100vw;
  height: 100vh;
  /*text-align: center;*/
}
#components-layout-demo-basic .ant-layout-sider {
  background: #ffffff;
  color: #fff;
  height: 100%;
}
#components-layout-demo-basic .ant-layout-header{
  background: #fff;
  color: #319ff3;
  height: 13%;
}
#components-layout-demo-basic .ant-layout-content {
  background: #ffffff;
  color: #ffffff;
  height: 58%;
}
#components-layout-demo-basic .ant-layout-footer {
  background: #fff;
  color: #319ff3;
  height: 32%;
}
#components-layout-demo-basic > .ant-layout {
  width: 100%;
  height: 100%;
}
#components-layout-demo-basic > .ant-layout:last-child {
  margin: 5px;
}
.row {
  text-align: left;
  font-size: 24px;
  color: #000000
}
.footrow {
  text-align: left;
  font-size: 31px;
  color: #000000
}
.divider {
  /*margin-top: 20px;*/
  color: #fa0000;
  font-size: 30px
}
</style>
